export default __webpack_public_path__ + "locales/pt-BR/Article.json?hash=c31bda8f6ee8c81f03ddbd8e2a57f716";